import React from 'react';
import { Route } from 'react-router-dom';


export const CustomRoute = ({...content}) => {
    return (<Route
        {...content}
    />);
};